import React from 'react';
import { SalesDeck } from './pages/SalesDeck';
export function App() {
  return <SalesDeck data-id="element-0" />;
}